<template>
    <section
        class="services"
        :class="[
            activeServiceCategory !== null && activeServiceIndex !== null ? `services--${activeServiceCategory}` : null,
            lastActiveCategory ? `${lastActiveCategory}-last-active` : null
        ]"
    >
        <div class="services__category-containers">
            <div class="services__category-container service__category-container--family">
                <slot
                    name="family_category_background_image"
                    v-cloak
                />
                <div class="services__category-overlay services__category-overlay--family"></div>
                <h1
                    v-if="this.serviceTypesShown === 'all' || this.serviceTypesShown === 'family'"
                    v-text="'Families'"
                    :data-wow-delay="delay"
                    class="services__category-title wow fadeInUp"
                />
                <div
                    v-if="this.serviceTypesShown === 'all' || this.serviceTypesShown === 'family'"
                    class="services__subheading-container"
                >
                    <slot name="brand-services-families-subheading"/>
                    <select
                        v-model="activeServiceIndex"
                        :data-wow-delay="delay"
                        class="services__category-select-container select-light wow fadeInUp"
                        @change="updateActiveService('family')"
                    >
                        <option :value="null"/>
                        <option
                            v-for="(service, index) in familyServices"
                            :value="index"
                            :key="index"
                            v-text="service.post_title"
                        />
                    </select>
                    <div class="services__category-button-container select-light wow fadeInUp">
                        <button
                            class="services__category-text"
                            @click.stop="toggleCategory('family')"
                            v-html="activeService ? activeService.post_title : '&nbsp;'"
                        />
                        <div class="services__category-spacer"/>
                        <transition name="services__category-buttons">
                            <div v-if="activeCategory === 'family'">
                                <button
                                    v-for="(service, index) in familyServices"
                                    :key="index"
                                    class="services__category-button"
                                    @click="handleClickEvent('family', index)"
                                    v-text="service.post_title"
                                />
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
            <div class="services__category-container service__category-container--institution">
                <slot
                    name="institution_category_background_image"
                    v-cloak
                />
                <div class="services__category-overlay services__category-overlay--institution"></div>
                <h1
                    v-if="this.serviceTypesShown === 'all' || this.serviceTypesShown === 'institution'"
                    v-text="'Institutions'"
                    :data-wow-delay="delay"
                    class="services__category-title wow fadeInUp"
                />
                <div
                    v-if="this.serviceTypesShown === 'all' || this.serviceTypesShown === 'institution'"
                    class="services__subheading-container"
                >
                    <slot name="brand-services-institutions-subheading"/>
                    <select
                        v-model="activeServiceIndex"
                        :data-wow-delay="delay"
                        class="services__category-select-container select-light wow fadeInUp"
                        @change="updateActiveService('institution')"
                    >
                        <option :value="null"/>
                        <option
                            v-for="(service, index) in institutionServices"
                            :value="index"
                            v-text="service.post_title"
                        />
                    </select>
                    <div class="services__category-button-container select-light wow fadeInUp">
                        <button
                            class="services__category-text"
                            @click.stop="toggleCategory('institution')"
                            v-html="activeService ? activeService.post_title : '&nbsp;'"
                        />
                        <div class="services__category-spacer"/>
                        <transition name="services__category-buttons">
                            <div v-if="activeCategory === 'institution'">
                                <button
                                    v-for="(service, index) in institutionServices"
                                    :key="index"
                                    class="services__category-button"
                                    @click="handleClickEvent('institution', index)"
                                    v-text="service.post_title"
                                />
                            </div>
                        </transition>
                    </div>
                    <!-- <h3
                        v-text="depluralizer(institutionServices[0].post_type)"
                        :data-wow-delay="delay"
                        class="brand-services__subheading brand-services__subheading--small wow fadeInUp"
                    /> -->
                </div>
            </div>
        </div>
        <article
            class="service"
            :class="activeService ? 'service--active' : null"
        >
            <button
                @click="activeServiceIndex = null"
                class="service__modal-close"
            >
                <svg viewBox="0 0 23.213 23.213" aria-hidden="true">
                   <use :xlink:href="themeLink + '/static/graphics/modal-close.svg#modal-close'"></use>
               </svg>
            </button>
            <div class="service__container">
                <div>
                    <!-- <h3
                        v-if="activeService"
                        v-text="activeService.post_type"
                        class="service__subheading"
                    /> -->
                    <h3
                        v-if="activeService"
                        v-text="activeService.post_title"
                        class="service__subheading"
                    />
                </div>
                <div
                    v-if="activeService"
                    v-text="activeService.header"
                    class="service__heading"
                />
                <svg viewBox="0 0 96.5 27.042" class="service__svg-group service__svg-group--top" aria-hidden="true">
                    <use :xlink:href="themeLink + '/dist/static/graphics/spiral-group.svg#spiral-group'"></use>
                </svg>
                <div
                    v-if="activeService"
                    v-text="activeService.copy"
                    class="service__content"
                />
                <h2
                    v-if="activeService"
                    v-text="options.contact_header"
                    class="service__heading service__heading--small"
                />
                <svg viewBox="0 0 96.5 27.042" class="service__svg-group service__svg-group--bottom" aria-hidden="true">
                    <use :xlink:href="themeLink + '/dist/static/graphics/spiral-group.svg#spiral-group'"></use>
                </svg>
                <p
                    v-if="activeService"
                    v-text="options.contact_copy"
                    class="service__content"
                />
                <a
                    v-if="activeService"
                    v-text="options.contact_link_text"
                    :href="options.contact_link"
                    class="service__link"
                />
        </div>
        </article>
    </section>
</template>

<script>
export default {
    name: 'BrandServices',
    props: {
        delay: {
            type: String,
            required: true,
        },
        themeLink: {
            type: String,
            required: true,
        },
        options: {
            type: Object,
            required: false,
        },
        familyServices: {
            type: Array,
            required: true,
        },
        institutionServices: {
            type: Array,
            required: true,
        },
        serviceType: {
            type: String,
        },
    },
    data() {
        return {
            activeCategory: null,
            lastActiveCategory: null,
            serviceTypesShown: 'all',
            activeServiceIndex: null,
            activeServiceCategory: null,
        };
    },
    computed: {
        activeService() {
            if (this.activeServiceIndex === null) {
                return null;
            }

            if (this.activeServiceCategory === 'institution') {
                return this.institutionServices[this.activeServiceIndex];
            }

            if (this.activeServiceCategory === 'family') {
                return this.familyServices[this.activeServiceIndex];
            }

            return null;
        },
    },
    methods: {
        depluralizer(str) {
            return str.slice(str.length - 1) === 's'
                ? str.slice(0, str.length - 1)
                : str;
        },
        updateActiveService(serviceType) {
            this.activeServiceCategory = serviceType;
            if (this.activeService) {
                history.replaceState({}, document.title, `#${this.activeService.slug}`);
            } else {
                history.replaceState({}, document.title, '#');
            }
        },
        handleClickEvent(category, index) {
            this.activeServiceIndex = index;
            this.updateActiveService(category);
            this.activeCategory = null;
        },
        toggleCategory(category) {
            this.activeCategory = this.activeCategory ? null : category;
        },
    },
    watch: {
        activeServiceCategory(newActiveServiceCategory) {
            if (newActiveServiceCategory !== null) {
                this.lastActiveCategory = newActiveServiceCategory;
            }
        },
    },
    mounted() {
        if (this.serviceType === 'family') {
            this.serviceTypesShown = 'family';
        }

        if (this.serviceType === 'institution') {
            this.serviceTypesShown = 'institution';
        }

        if (window.location.hash.substr(1)) {
            const requestedServiceSlug = window.location.hash.substr(1);

            this.familyServices.forEach((service) => {
                if (requestedServiceSlug === service.slug) {
                    this.activeServiceIndex = this.familyServices.indexOf(service);
                    this.activeServiceCategory = 'family';
                }
            });

            this.institutionServices.forEach((service) => {
                if (requestedServiceSlug === service.slug) {
                    this.activeServiceIndex = this.institutionServices.indexOf(service);
                    this.activeServiceCategory = 'institution';
                }
            });
        }

        addEventListener('click', () => { this.activeCategory = null; });
    },
};
</script>



// WEBPACK FOOTER //
// BrandServices.vue?15120974